export default "__VITE_ASSET__CzOMmOVC__"